var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3014",
    "data-name": "Groupe 3014",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 42.5,
    viewBox: "0 0 44 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 44,
    height: 42.5,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3013",
    "data-name": "Groupe 3013",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36668",
    "data-name": "Trac\\xE9 36668",
    d: "M17.5,0a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36669",
    "data-name": "Trac\\xE9 36669",
    d: "M26.5,0a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_272",
    "data-name": "Ligne 272",
    x2: 17,
    transform: "translate(13.5 9.5)",
    fill: "none",
    stroke: "#cea95a",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36670",
    "data-name": "Trac\\xE9 36670",
    d: "M39.5,42.5a4,4,0,1,1,4-4,4,4,0,0,1-4,4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36671",
    "data-name": "Trac\\xE9 36671",
    d: "M30.5,42.5a4,4,0,1,1,4-4,4,4,0,0,1-4,4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_273",
    "data-name": "Ligne 273",
    x1: 17,
    transform: "translate(26.5 33)",
    fill: "none",
    stroke: "#cea95a",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36672",
    "data-name": "Trac\\xE9 36672",
    d: "M13.5,42.5a4,4,0,1,1,4-4,4,4,0,0,1-4,4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36673",
    "data-name": "Trac\\xE9 36673",
    d: "M4.5,42.5a4,4,0,1,1,4-4,4,4,0,0,1-4,4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_274",
    "data-name": "Ligne 274",
    x1: 17,
    transform: "translate(0.5 33)",
    fill: "none",
    stroke: "#cea95a",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36674",
    "data-name": "Trac\\xE9 36674",
    d: "M39.5,27.5a4,4,0,1,1,4-4,4,4,0,0,1-4,4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36675",
    "data-name": "Trac\\xE9 36675",
    d: "M30.5,27.5a4,4,0,1,1,4-4,4,4,0,0,1-4,4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_275",
    "data-name": "Ligne 275",
    x1: 17,
    transform: "translate(26.5 18)",
    fill: "none",
    stroke: "#cea95a",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36676",
    "data-name": "Trac\\xE9 36676",
    d: "M13.5,27.5a4,4,0,1,1,4-4,4,4,0,0,1-4,4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36677",
    "data-name": "Trac\\xE9 36677",
    d: "M4.5,27.5a4,4,0,1,1,4-4,4,4,0,0,1-4,4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_276",
    "data-name": "Ligne 276",
    x1: 17,
    transform: "translate(0.5 18)",
    fill: "none",
    stroke: "#cea95a",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.fbda522dc3d6cac1f9388359767ae55d.svg";
export { ForwardRef as ReactComponent };